import { VisasqNowSectionName } from '@/types';

// 計測で使用するビザスクNOWの依頼文生成に関する機能名
export const VISASQ_NOW_FEATURE_NAME = 'visasq_request_generate';

export const VISASQ_NOW_SECTION_NAMES: Array<VisasqNowSectionName> = [
  '案件タイトル',
  '調査背景と目的',
  '質問文',
  '回答例',
];
